module.exports = __webpack_public_path__ + "img/disabled.13ced231.svg";